import { useTheme } from "@my-saas/hooks";
import { cn } from "@my-saas/utils";

type Props = {
  size?: number;
  className?: string;
  variant?: "icon" | "wordmark";
};

/**
 * cig.chat brand mark. `variant="icon"` for compact spots (sidebar);
 * `variant="wordmark"` (default) for the full chat-bubble + "CIG.IL" wordmark.
 */
export const Logo = ({ size = 32, className, variant = "wordmark" }: Props) => {
  const { isDarkMode } = useTheme();
  const suffix = isDarkMode ? "-white" : "";
  const src =
    variant === "icon" ? `/cig/cig-icon${suffix}.svg` : `/cig/cig-logo${suffix}.svg`;
  const aspect = variant === "icon" ? 1 : 393.87 / 210.07;

  return (
    <img
      src={src}
      width={Math.round(size * aspect)}
      height={size}
      alt="cig.chat"
      className={cn("select-none", className)}
    />
  );
};
